import Button from '@components/ui/button.vue';
import Count from '@components/ui/count.vue';

import { mapGetters, mapMutations } from 'vuex';

export default {
  data: function() {
    return {
      items: [],
    };
  },
  components: {
    't-count': Count,
    't-button': Button,
  },
  methods: {
    ...mapMutations('cart', ['addItemToCart']),
    ...mapGetters('cart', ['checkInCart']),
    buttonContent: function(id) {
      return this.checkInCart()(id) ? 'В корзине' : 'В корзину';
    },
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/products-grid/products/middleBlock/script.js